import { createSlice } from "@reduxjs/toolkit";
import { lastTwentyFourHoursDateRange } from "../../helpers/lastTwentyFourHoursDateRage";

const initialState = {
  dateRangeValue: lastTwentyFourHoursDateRange() ?? {},
};

const dateRangeSlice = createSlice({
  name: "dateRange",
  initialState,
  reducers: {
    storeDateRange: (state, action) => {
      state.dateRangeValue = action.payload;
    },
    resetDateRange: (state) => {
      state.dateRangeValue = lastTwentyFourHoursDateRange();
    },
  },
});

export const { storeDateRange, resetDateRange } = dateRangeSlice.actions;

export default dateRangeSlice.reducer;
